import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import UserLog from "./userLog";

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {},
        dispatch
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(UserLog);
